<template>
    <div ref="modal" class="modal-wrap">
        <div class="modal-overlay" @click.prevent="animateModalOut"></div>
        <div class="modal">
            <button class="null modal-close" title="Close" @click.prevent="animateModalOut">
                <icon-x></icon-x>
            </button>
            <component :is="currentComponent"></component>
            <div>
                <a v-if="isLoginForm" href="/forgot-password" @click.prevent="showForgotPasswordComponent">Forgot Password</a>
                <a v-if="!isLoginForm && isForgotPasswordForm" href="/login" @click.prevent="showLoginComponent">Sign In</a>
                <span v-if="isLoginForm || isForgotPasswordForm"> | </span>
                <a v-if="isLoginForm || isForgotPasswordForm" href="/register" @click.prevent="showRegisterComponent">New Account</a>
                <a v-if="!isLoginForm && !isForgotPasswordForm" href="/login" @click.prevent="showLoginComponent">Sign In</a>
            </div>
        </div>
    </div>
</template>

<script>
    import Login          from "./Login";
    import Register       from "./Register";
    import ForgotPassword from "../Auth/ForgotPassword";
    import IconX          from "../../../../Lib/Icons/IconX";
    import { TweenMax }   from "gsap";
    import isInApp        from "../../../../Lib/helpers/isInApp";

    export default {
        name      : "modal",
        components: { Login, Register, IconX },

        data() {
            return {
                currentComponent    : Login,
                isLoginForm         : true,
                isForgotPasswordForm: false,
            }
        },

        methods: {
            showRegisterComponent() {
                this.currentComponent = Register;
                this.isLoginForm = false;
                this.isForgotPasswordForm = false;
            },

            showLoginComponent() {
                this.currentComponent = Login;
                this.isLoginForm = true;
                this.isForgotPasswordForm = false;
            },

            showForgotPasswordComponent() {
                this.currentComponent = ForgotPassword;
                this.isLoginForm = false;
                this.isForgotPasswordForm = true;
            },

            resetModalAnimation() {
                TweenMax.set(this.$refs.modal, {
                    autoAlpha: 0,
                });
            },

            animateModalIn() {
                TweenMax.set(this.$refs.modal, {
                    autoAlpha: 0,
                });
                TweenMax.fromTo(this.$refs.modal, 0.5, {
                    autoAlpha: 0,
                    scale    : 1.15,
                    ease     : Power4.ease,
                }, {
                    autoAlpha: 1,
                    scale    : 1,
                    ease     : Power4.ease,
                });
            },

            animateModalOut() {
                TweenMax.to(this.$refs.modal, 0.25, {
                    autoAlpha: 0,
                    scale    : 1.15,
                    ease     : Power4.ease,
                });
            },

            unFocusLinks() {
                // This is used for when the modal changes forms (ie. Login > Sign In)
                // the link clicked to switch forms will no longer carry the focused state
                // over to the new form.
                let link = document.querySelectorAll('a');
                
                for(let i = 0; i < link.length; i++) {
                    link[i].blur();
                }
            },
        },

        mounted() {
            this.resetModalAnimation();
            
            window.Broadcast.$on('unauthenticated', () => {
                if(isInApp()) this.animateModalIn();
            });
        },

        updated() {
            this.unFocusLinks();
        }
    }
</script>
